import ServiceCRUD from '../../../../services/ServiceCRUDFLEXUC';

class RoleService extends ServiceCRUD {
  constructor() {
    super(`/api/roles`);
  }
}

export default new RoleService();
